/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * WSM API Specification
 * OpenAPI spec version: 0.0.8
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV8ApplicationWsmActiveTransactionsDetailParams,
  GetV8ApplicationWsmActiveTransactionsParams,
  GetV8ApplicationWsmCacheParams,
  GetV8ApplicationWsmConfigParams,
  GetV8ApplicationWsmInfoParams,
  GetV8ApplicationWsmUpstreamParams,
  GetV8ApplicationWsmWorkerParams,
  WsmActiveTransactionResponse,
  WsmCacheResponse,
  WsmConfigResponse,
  WsmInfoResponse,
  WsmUpstreamResponse,
  WsmWorkerResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getWsmActiveTransactions
 */
export const getV8ApplicationWsmActiveTransactions = (
  params?: MaybeRef<GetV8ApplicationWsmActiveTransactionsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WsmActiveTransactionResponse>(
    {
      url: `/api/v8/application/wsm/active-transactions`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV8ApplicationWsmActiveTransactionsQueryKey = (
  params?: MaybeRef<GetV8ApplicationWsmActiveTransactionsParams>,
) => {
  return [
    'api',
    'v8',
    'application',
    'wsm',
    'active-transactions',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV8ApplicationWsmActiveTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactions>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8ApplicationWsmActiveTransactionsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ApplicationWsmActiveTransactionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactions>>
  > = ({ signal }) => getV8ApplicationWsmActiveTransactions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactions>>,
    TError,
    TData
  >;
};

export type GetV8ApplicationWsmActiveTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactions>>
>;
export type GetV8ApplicationWsmActiveTransactionsQueryError = ErrorType<unknown>;

/**
 * @summary getWsmActiveTransactions
 */

export function useGetV8ApplicationWsmActiveTransactions<
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactions>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8ApplicationWsmActiveTransactionsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ApplicationWsmActiveTransactionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getWsmActiveTransactionsDetail
 */
export const getV8ApplicationWsmActiveTransactionsDetail = (
  params: MaybeRef<GetV8ApplicationWsmActiveTransactionsDetailParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WsmActiveTransactionResponse>(
    {
      url: `/api/v8/application/wsm/active-transactions/detail`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV8ApplicationWsmActiveTransactionsDetailQueryKey = (
  params?: MaybeRef<GetV8ApplicationWsmActiveTransactionsDetailParams>,
) => {
  return [
    'api',
    'v8',
    'application',
    'wsm',
    'active-transactions',
    'detail',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV8ApplicationWsmActiveTransactionsDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactionsDetail>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmActiveTransactionsDetailParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactionsDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ApplicationWsmActiveTransactionsDetailQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactionsDetail>>
  > = ({ signal }) => getV8ApplicationWsmActiveTransactionsDetail(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactionsDetail>>,
    TError,
    TData
  >;
};

export type GetV8ApplicationWsmActiveTransactionsDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactionsDetail>>
>;
export type GetV8ApplicationWsmActiveTransactionsDetailQueryError = ErrorType<unknown>;

/**
 * @summary getWsmActiveTransactionsDetail
 */

export function useGetV8ApplicationWsmActiveTransactionsDetail<
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactionsDetail>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmActiveTransactionsDetailParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8ApplicationWsmActiveTransactionsDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ApplicationWsmActiveTransactionsDetailQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getWsmCache
 */
export const getV8ApplicationWsmCache = (
  params: MaybeRef<GetV8ApplicationWsmCacheParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WsmCacheResponse>(
    { url: `/api/v8/application/wsm/cache`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8ApplicationWsmCacheQueryKey = (
  params?: MaybeRef<GetV8ApplicationWsmCacheParams>,
) => {
  return ['api', 'v8', 'application', 'wsm', 'cache', ...(params ? [params] : [])] as const;
};

export const getGetV8ApplicationWsmCacheQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmCache>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmCacheParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ApplicationWsmCache>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ApplicationWsmCacheQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ApplicationWsmCache>>> = ({
    signal,
  }) => getV8ApplicationWsmCache(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ApplicationWsmCache>>,
    TError,
    TData
  >;
};

export type GetV8ApplicationWsmCacheQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ApplicationWsmCache>>
>;
export type GetV8ApplicationWsmCacheQueryError = ErrorType<unknown>;

/**
 * @summary getWsmCache
 */

export function useGetV8ApplicationWsmCache<
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmCache>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmCacheParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ApplicationWsmCache>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ApplicationWsmCacheQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getWsmConfigs
 */
export const getV8ApplicationWsmConfig = (
  params: MaybeRef<GetV8ApplicationWsmConfigParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WsmConfigResponse>(
    { url: `/api/v8/application/wsm/config`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8ApplicationWsmConfigQueryKey = (
  params?: MaybeRef<GetV8ApplicationWsmConfigParams>,
) => {
  return ['api', 'v8', 'application', 'wsm', 'config', ...(params ? [params] : [])] as const;
};

export const getGetV8ApplicationWsmConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmConfig>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmConfigParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ApplicationWsmConfig>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ApplicationWsmConfigQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ApplicationWsmConfig>>> = ({
    signal,
  }) => getV8ApplicationWsmConfig(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ApplicationWsmConfig>>,
    TError,
    TData
  >;
};

export type GetV8ApplicationWsmConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ApplicationWsmConfig>>
>;
export type GetV8ApplicationWsmConfigQueryError = ErrorType<unknown>;

/**
 * @summary getWsmConfigs
 */

export function useGetV8ApplicationWsmConfig<
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmConfig>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmConfigParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ApplicationWsmConfig>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ApplicationWsmConfigQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getWsmInfo
 */
export const getV8ApplicationWsmInfo = (
  params: MaybeRef<GetV8ApplicationWsmInfoParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WsmInfoResponse>(
    { url: `/api/v8/application/wsm/info`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8ApplicationWsmInfoQueryKey = (
  params?: MaybeRef<GetV8ApplicationWsmInfoParams>,
) => {
  return ['api', 'v8', 'application', 'wsm', 'info', ...(params ? [params] : [])] as const;
};

export const getGetV8ApplicationWsmInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmInfo>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmInfoParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ApplicationWsmInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ApplicationWsmInfoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ApplicationWsmInfo>>> = ({
    signal,
  }) => getV8ApplicationWsmInfo(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ApplicationWsmInfo>>,
    TError,
    TData
  >;
};

export type GetV8ApplicationWsmInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ApplicationWsmInfo>>
>;
export type GetV8ApplicationWsmInfoQueryError = ErrorType<unknown>;

/**
 * @summary getWsmInfo
 */

export function useGetV8ApplicationWsmInfo<
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmInfo>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmInfoParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ApplicationWsmInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ApplicationWsmInfoQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getWsmUpstream
 */
export const getV8ApplicationWsmUpstream = (
  params: MaybeRef<GetV8ApplicationWsmUpstreamParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WsmUpstreamResponse>(
    { url: `/api/v8/application/wsm/upstream`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8ApplicationWsmUpstreamQueryKey = (
  params?: MaybeRef<GetV8ApplicationWsmUpstreamParams>,
) => {
  return ['api', 'v8', 'application', 'wsm', 'upstream', ...(params ? [params] : [])] as const;
};

export const getGetV8ApplicationWsmUpstreamQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmUpstream>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmUpstreamParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ApplicationWsmUpstream>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ApplicationWsmUpstreamQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ApplicationWsmUpstream>>> = ({
    signal,
  }) => getV8ApplicationWsmUpstream(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ApplicationWsmUpstream>>,
    TError,
    TData
  >;
};

export type GetV8ApplicationWsmUpstreamQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ApplicationWsmUpstream>>
>;
export type GetV8ApplicationWsmUpstreamQueryError = ErrorType<unknown>;

/**
 * @summary getWsmUpstream
 */

export function useGetV8ApplicationWsmUpstream<
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmUpstream>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmUpstreamParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ApplicationWsmUpstream>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ApplicationWsmUpstreamQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getWsmWorker
 */
export const getV8ApplicationWsmWorker = (
  params: MaybeRef<GetV8ApplicationWsmWorkerParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WsmWorkerResponse>(
    { url: `/api/v8/application/wsm/worker`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8ApplicationWsmWorkerQueryKey = (
  params?: MaybeRef<GetV8ApplicationWsmWorkerParams>,
) => {
  return ['api', 'v8', 'application', 'wsm', 'worker', ...(params ? [params] : [])] as const;
};

export const getGetV8ApplicationWsmWorkerQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmWorker>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmWorkerParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ApplicationWsmWorker>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ApplicationWsmWorkerQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8ApplicationWsmWorker>>> = ({
    signal,
  }) => getV8ApplicationWsmWorker(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ApplicationWsmWorker>>,
    TError,
    TData
  >;
};

export type GetV8ApplicationWsmWorkerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ApplicationWsmWorker>>
>;
export type GetV8ApplicationWsmWorkerQueryError = ErrorType<unknown>;

/**
 * @summary getWsmWorker
 */

export function useGetV8ApplicationWsmWorker<
  TData = Awaited<ReturnType<typeof getV8ApplicationWsmWorker>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8ApplicationWsmWorkerParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8ApplicationWsmWorker>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ApplicationWsmWorkerQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
